import { render, staticRenderFns } from "./EditVehicleUsage.vue?vue&type=template&id=87dcff12"
import script from "./EditVehicleUsage.vue?vue&type=script&lang=ts"
export * from "./EditVehicleUsage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports